<template>
    <div class="settings-field">
        <p class="title">
            {{ configTitle }}:
        </p>
        <div class="options">
            <template v-if="'select' !== inputType">
                <div
                    v-for="field in fieldsConfig"
                    :key="field.value"
                    class="settings-option"
                >
                    <input
                        v-model="value"
                        :type="inputType"
                        :value="field.value || null "
                        :class="[...inputClass]"
                        :disabled="isDisabled(field.value)"
                        @blur="urlInputPrefix"
                    >
                    <label
                        v-if="field.label"
                        :class="[...labelClass]"
                    >
                        {{ field.label }}
                    </label>
                    <base-label
                        v-if="isDisabled(field.value)"
                        :class="['is-green']"
                    >
                        Pro
                    </base-label>
                </div>
            </template>
            <template v-else>
               <base-select
                    :initial-value="value"
                    :options="fieldsConfig"
                    :container-class="['is-large']"
                    :disabled="! isActive"
                    @change="value => $emit('change', { [settingsKey]: value })"
                />
                <base-label
                    v-if="! isActive"
                    :class="['is-green']"
                >
                    Pro
                </base-label>
            </template>
        </div>
    </div>
</template>

<script>
import prefixUrlInput from '@/utils/form/prefixUrlInput';

export default {
    props: {
        configTitle: {
            type: String,
            required: true,
        },
        inputType: {
            type: String,
            required: true,
        },
        fieldsConfig: {
            type: Array,
            required: true,
        },
        bindedValue: {
            type: [Array, String, Boolean],
            required: true,
        },
        settingsKey: {
            type: String,
            required: true,
        },
        inputClass: {
            type: Array,
            default: () => [],
        },
        labelClass: {
            type: Array,
            default: () => [],
        },
        isActive: {
            type: Boolean,
            default: true,
        },
        availableOptions: {
            type: [Array, Boolean],
            default: false,
        },
    },

    computed: {
        value: {
            /**
             * Computed getter
             *
             * @returns {string} Player type.
             */
            get() {
                return this.isBooleanRadio()
                    ? this.bindedValue.toString() : this.bindedValue;
            },

            /**
             * Computed setter
             *
             * @param   {string}  value  Config value
             *
             */
            set(value) {
                if (this.isBooleanRadio()) {
                    value = 'true' === String(value).toLowerCase();
                }

                this.$emit('change', { [this.settingsKey]: value });
            },
        },
    },

    methods: {
        /**
         * Check if is free option
         *
         * @param   {string}  value  Input value
         *
         * @returns  {boolean}       If is free option
         */
        isFreeOption(value) {
            return this.availableOptions.includes(value);
        },

        /**
         * Check if is free option
         *
         * @param   {string}  value  Input value
         *
         * @returns  {boolean}       If is free option
         */
        isDisabled(value) {
            return (! this.isActive && value !== this.value) ||
                (this.availableOptions &&
                    ! this.availableOptions.includes(value));
        },

        /**
         * Check it this is a radio field with boolean value
         *
         * @returns {boolean} True if radio type with boolean value
         */
        isBooleanRadio() {
            return 'radio' === this.inputType &&
                'boolean' === typeof this.bindedValue;
        },

        /**
         * Prefixes url input
         *
         *
         */
        urlInputPrefix() {
            if ('url' === this.settingsKey) {
                this.value = prefixUrlInput(this.value);
            }
        },
    },
};
</script>
